import React from 'react';
import { brands, warrantyBrands, testimonials } from '../../data/mock';
import { Star, Quote, ShieldCheck } from 'lucide-react';

export default function Brands() {
  return (
    <section id="marchi" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-sky-600 text-xs font-bold uppercase tracking-[0.2em]">Marchi che ripariamo</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">Multimarca, per davvero</h2>
          <p className="mt-4 text-slate-600 text-lg">Lavoriamo con tutti i principali brand del mercato e moltissimi marchi minori. Se non vedi il tuo, chiamaci.</p>
        </div>

        <div className="mt-12 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3">
          {brands.map((b) => (
            <div key={b} className="flex items-center justify-center h-16 px-4 rounded-xl bg-slate-50 border border-slate-200 text-slate-700 font-bold text-sm hover:bg-sky-50 hover:border-sky-300 hover:text-sky-700 transition-colors">
              {b}
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-3xl bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 p-8 lg:p-12">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-amber-500 text-white flex items-center justify-center flex-shrink-0 shadow-md">
                <ShieldCheck className="w-6 h-6" />
              </div>
              <div>
                <div className="text-amber-700 text-xs font-bold uppercase tracking-[0.2em]">Centro autorizzato</div>
                <h3 className="mt-1 text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">Marchi in garanzia</h3>
                <p className="mt-2 text-slate-700 max-w-2xl">Siamo centro di assistenza ufficiale autorizzato per la gestione diretta della garanzia dei seguenti marchi:</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {warrantyBrands.map((b) => (
              <div key={b} className="flex items-center justify-center h-16 px-4 rounded-xl bg-white border border-amber-200 text-slate-800 font-bold text-sm hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-colors shadow-sm">
                {b}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24">
          <div className="text-center max-w-2xl mx-auto">
            <div className="text-sky-600 text-xs font-bold uppercase tracking-[0.2em]">Dicono di noi</div>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">La fiducia dei nostri clienti</h2>
            <div className="mt-5 inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-white border border-slate-200 shadow-sm">
              <svg viewBox="0 0 24 24" className="w-5 h-5">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <div className="flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <span className="text-sm font-bold text-slate-900">4.9/5</span>
              <span className="text-sm text-slate-600">su Google</span>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.name} className="relative bg-slate-50 rounded-2xl p-7 border border-slate-200 hover:border-sky-300 hover:shadow-lg transition-all">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-sky-200" />
                <div className="flex items-center gap-1">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="mt-4 text-slate-700 leading-relaxed">“{t.content}”</p>
                <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-sky-500 to-blue-700 text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                    {t.name.split(' ').map((s) => s[0]).slice(0, 2).join('')}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="font-bold text-slate-900 truncate">{t.name}</div>
                    <div className="text-xs text-slate-500 truncate">{t.role}</div>
                  </div>
                  <svg viewBox="0 0 24 24" className="w-5 h-5 flex-shrink-0">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <a
              href="https://www.google.com/search?sxsrf=ANbL-n4lMydjJAh4b7VqsMrAcTBwGUO14A:1778075376282&q=GT+Assistenza+Recensioni&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxK2MDEzAQIjAyMLS0MTC0NTY4MNjIyvGCXcQxQci4szi0tS86oSFYJSk1PzijPz8zIXseKUAgA2GLdQUAAAAA&rldimm=8464444202891481530&tbm=lcl&hl=it-IT#lkt=LocalPoiReviews"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white border border-slate-300 text-slate-800 font-semibold hover:border-sky-400 hover:text-sky-700 transition-colors shadow-sm"
            >
              Leggi tutte le recensioni su Google
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
